import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { JwtService } from '../index.service';
import { catchError, distinctUntilChanged, filter, first, mergeMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {
  readonly BASE_URL = environment.BASE_API_URL;

  constructor(
    private http:HttpClient,
    private jwtService:JwtService
  ) { }

  requestJoinToTeamByUser(organUsername:string){
    return this.http.post<any>(`${this.BASE_URL}team/${organUsername}/member/request_to_join/`,{})
  }
  cancelJoinToTeam(organUsername:string){
    return this.http.delete<any>(`${this.BASE_URL}team/${organUsername}/member/unsubscribe/`,{})
  }

  organSubscribeUserList(page:number=1,search:string=''){
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      distinctUntilChanged(),
      mergeMap((account:any)=>{
        return this.http.get<any>(`${this.BASE_URL}team/${account.username}/member/?page=${page}&search=${search}`).pipe(
          catchError(err=>{throw err})
        )
      }),
    )
  }
  organUnsubscribeUserList(page:number=1){
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      distinctUntilChanged(),
      mergeMap((account:any)=>{
        return this.http.get<any>(`${this.BASE_URL}team/${account.username}/member/unverified/?page=${page}`).pipe(
          catchError(err=>{throw err})
        )
      }),
    )
  }
  userSubscribeOrganList(page:number=1,search:string=''){
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      distinctUntilChanged(),
      mergeMap((account:any)=>{
        return this.http.get<any>(`${this.BASE_URL}team/?is_verified=true&page=${page}`).pipe(
          catchError(err=>{throw err})
        )
      }),
    )
  }
  userUnsubscribeOrganList(page:number=1,search:string=''){
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      distinctUntilChanged(),
      mergeMap((account:any)=>{
        return this.http.get<any>(`${this.BASE_URL}team/?is_verified=false&page=${page}`).pipe(
          catchError(err=>{throw err})
        )
      }),
    )
  }
  acceptSubscriber(item:any,label:any){
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      distinctUntilChanged(),
      mergeMap((account:any)=>{
        return this.http.post<any>(`${this.BASE_URL}team/${account.username}/member/${item.id}/verify/`,{label:!label?'':label}).pipe(
          catchError(err=>{throw err})
        )
      }),
    )
  }
  editSubscriberLabel(item:any,label:any){
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      distinctUntilChanged(),
      mergeMap((account:any)=>{
        return this.http.put<any>(`${this.BASE_URL}team/${account.username}/member/${item.id}/`,{label:!label?'':label}).pipe(
          catchError(err=>{throw err})
        )
      }),
    )
  }
  rejectSubscriberRequest(item:any){
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account:any)=>account && account.username),
      distinctUntilChanged(),
      mergeMap((account:any)=>{
        return this.http.delete<any>(`${this.BASE_URL}team/${account.username}/member/${item.id}/`).pipe(
          catchError(err=>{throw err})
        )
      }),
    )
  }
}